import { riserRnOku } from "./riser-dosyasi.js";
import { pkgNo } from "./stok-paket.js";
/* ====================================================================================================================
 * 1 · Sözlükler
 * ================================================================================================================== */
/** Beş ana kalem: ana gövde, Choke, Kill, Booster, Hydraulic. Sıra ekrandaki satır sırasıdır. */
export const SUREKLILIK_KALEMLERI = ["MB", "C", "K", "B", "H"];
export const SUREKLILIK_SONUCLARI = ["ayni", "yazim_farki", "farkli", "rol_farki", "kaynak_yok", "belirsiz"];
/** Kişinin beyanı (`montaj_birim.bag_turu`; kalıcı değerler). */
export const MONTAJ_BAG_TURLERI = ["ayni", "baska_riser", "stok", "bilinmiyor"];
export const montajBagTuruMu = (x) => typeof x === "string" && MONTAJ_BAG_TURLERI.includes(x);
/** Kalemin Riser Documentation'daki hattı (köken satırının `hat` değeri). */
export const KALEM_HATTI = { MB: "Main", C: "Choke", K: "Kill", B: "Booster", H: "Hydraulic" };
/** Ana kalemlerin FM-0012 satır numarası. */
export const ANA_KALEM_SATIRI = { MB: 1, CK: 3, B: 4, H: 5 };
/** Yan yana gösterilen küçük parça satırları (FM-0012 satır numarası), ekrandaki sırayla. */
export const KUCUK_PARCA_SATIRLARI = [2, 6, 7, 8, 11, 9, 10, 30];
/**
 * Sonucun ekran metni (İngilizce sabit; web `cevir(degisken)` ile gösterir, sözlük satırları elle eklenir).
 * `rol_farki` metni iki hat karşılıklı yer değiştirdiğinde geçerlidir; tek hatta `ROL_FARKI_TEK_HAT_METNI` yazılır.
 */
export const SUREKLILIK_SONUC_METNI = {
    ayni: "same",
    yazim_farki: "same, written differently",
    farkli: "different",
    rol_farki: "same line, Choke and Kill swapped",
    kaynak_yok: "nothing to compare",
    belirsiz: "uncertain reading",
};
/** Riserın kendi hattı öteki yuvada, karşı yuvaya başka hat takılmış. */
export const ROL_FARKI_TEK_HAT_METNI = "same line, now in the other slot";
/** Satırın sonuç metni: `rol_farki` tek hatta ise "same line, now in the other slot", değilse sözlükteki metin. */
export function sureklilikSonucMetni(s) {
    return s.sonuc === "rol_farki" && s.rolFarki === "oteki_yuva" ? ROL_FARKI_TEK_HAT_METNI : SUREKLILIK_SONUC_METNI[s.sonuc];
}
const ROL_ADI = { C: "Choke", K: "Kill" };
const YUVALAR = ["C", "K"];
const rolMu = (x) => x === "C" || x === "K";
/**
 * Ana kalemin olay ve hata cümlelerindeki adı: satır 1 "Main Tube" · satır 3 rolüyle "Choke line" / "Kill line", rol yoksa
 * "C&K line" · satır 4 "Booster line" · satır 5 "Hydraulic line". Ana kalem satırı değilse "row {n}".
 */
export function montajAnaKalemAdi(sira, rol = null) {
    if (sira === ANA_KALEM_SATIRI.MB)
        return "Main Tube";
    if (sira === ANA_KALEM_SATIRI.CK)
        return rol ? `${ROL_ADI[rol]} line` : "C&K line";
    if (sira === ANA_KALEM_SATIRI.B)
        return "Booster line";
    if (sira === ANA_KALEM_SATIRI.H)
        return "Hydraulic line";
    return `row ${sira}`;
}
/* ====================================================================================================================
 * 2 · Kimlik ilişkisi
 * ================================================================================================================== */
/** Ana kalem kimliği en az dört rakamlık bir parça taşır (var olan kural: hat kimliği hiçbir zaman 1–3 haneli çıplak sayı değildir). */
export const kimlikGecerliMi = (sn) => typeof sn === "string" && /\d{4,}/.test(sn);
/**
 * Düzenleme uzaklığı tam 1: bir karakter değişmiş, eklenmiş ya da silinmiş ("9994830-2" ↔ "9994830-3"; "9995210-1" ↔ "9995210-10").
 * Eşit değerde false. Sunucudaki `tekKarakterFarkli`'dan geniştir (o yalnız aynı uzunlukta değişimi sayar).
 */
export function birKarakterUzak(a, b) {
    if (a === b)
        return false;
    const [kisa, uzun] = a.length <= b.length ? [a, b] : [b, a];
    if (uzun.length - kisa.length > 1)
        return false;
    let i = 0;
    while (i < kisa.length && kisa[i] === uzun[i])
        i++;
    return kisa.length === uzun.length ? kisa.slice(i + 1) === uzun.slice(i + 1) : kisa.slice(i) === uzun.slice(i + 1);
}
/** Tireler atılınca eşit ve en az altı rakam taşıyor: "99072991" ≡ "9907299-1". */
export function ayracsizEsit(a, b) {
    const x = a.replace(/-/g, "");
    return x === b.replace(/-/g, "") && (x.match(/\d/g)?.length ?? 0) >= 6;
}
/** İki temiz kimliğin ilişkisi. Sıra: eşit → "ayni" · ayracsizEsit → "yazim" · birKarakterUzak → "yakin" · değilse "farkli". */
export function kimlikIliskisi(a, b) {
    if (a === b)
        return "ayni";
    if (ayracsizEsit(a, b))
        return "yazim";
    return birKarakterUzak(a, b) ? "yakin" : "farkli";
}
/**
 * Stok izi ve PO karşılaştırmasının sade normalleştirmesi: büyük harf, boşluksuz, tireyle ayrılan sayısal parçaların baştaki
 * sıfırı atılmış (" 0012-07 " → "12-7"; "b 90159" → "B90159"). Harfle başlayan parçanın sıfırına dokunulmaz. Boş değer "".
 */
export function sadeKimlik(s) {
    return (s ?? "")
        .toUpperCase()
        .replace(/\s+/g, "")
        .split("-")
        .map((p) => (/^\d+$/.test(p) ? p.replace(/^0+(?=\d)/, "") : p))
        .join("-");
}
export const SUREKLILIK_ISARETLERI = [
    "kendi_degerine_yakin", "rol_yazilmamis", "rol_sirayla", "rol_cift", "sokum_farkli", "oem_farkli",
    "cikan_is_emri", "cikan_is_emri_ayni_sayi", "cikan_eski_yok", "mt_weldment", "mt_alt_parca", "baslik_farkli",
    "okuma_belirsiz", "kimlik_okunamadi", "mrb_diger", "sokuldu", "ayni_sn_iki_birim", "fazla_birim", "sayfa_eksik",
];
const tekil = (d) => [...new Set(d)];
const seqSirasi = (d) => [...d].sort((a, b) => a.seq - b.seq);
/** Aynı temiz kolona düşen değerler " · " ile birleşik gelir; parçalarına ayrılır. */
const parcala = (deger) => (deger ?? "").split(/\s*·\s*/).map((x) => x.trim()).filter(Boolean);
const otekiler = (d, asil) => d.filter((x) => x !== asil).map((deger) => ({ tur: "oteki_deger", deger }));
/**
 * İki C&K birimini (satır 3, `seq`'i en küçük ikisi) C ve K yuvasına yerleştirir. Sıra:
 * 1. Rol: formdaki harfi dolu birim o yuvaya girer ("kayit"); iki birim aynı harfi taşıyorsa ilki yerleşir, `rolCift` true olur.
 *    Formda harfi olmayan ve kişinin rol seçtiği birim (`rolSecim`) boş yuvasına girer ("ekran"); yuva formdaki harfle dolmuşsa
 *    seçim yok sayılır (formda yazan kanıttır).
 * 2. Sökümdeki SN: yerleşmemiş birimin kimliği sökümün ROLÜ DOLU C birimine eşitse boş C yuvasına, K birimine eşitse boş K
 *    yuvasına girer ("sokum"). Sökümün rolsüz birimi yerleşimde kullanılmaz.
 * 3. Öteki hat: tek birim ve tek boş yuva kaldıysa kalan birim kalan yuvaya girer ("diger_hat").
 * 4. Formdaki sıra: kalanlar `seq` sırasıyla boş yuvalara girer; ilki C satırında, ikincisi K satırında gösterilir ("sira").
 * Yerleşim yalnız GÖSTERİM içindir: 2–4. kurallar `montaj_birim.rol`'e ve `rol_secim`'e hiçbir şey yazdırmaz.
 */
export function ckYuvalari(birimler, sokumCk) {
    const sirali = seqSirasi(birimler.filter((b) => b.sira === ANA_KALEM_SATIRI.CK));
    const iki = sirali.slice(0, 2);
    const yuva = { C: null, K: null };
    const yerlesen = new Set();
    const yerlestir = (birim, rol, kaynak) => {
        yuva[rol] = { birim, kaynak };
        yerlesen.add(birim.id);
    };
    let rolCift = false;
    for (const b of iki) {
        if (!b.rol)
            continue;
        if (yuva[b.rol])
            rolCift = true;
        else
            yerlestir(b, b.rol, "kayit");
    }
    for (const b of iki)
        if (!b.rol && b.rolSecim && !yuva[b.rolSecim])
            yerlestir(b, b.rolSecim, "ekran");
    const sokumSn = (rol) => sokumCk.find((s) => s.rol === rol && kimlikGecerliMi(s.eski.sn))?.eski.sn ?? null;
    for (const b of iki) {
        if (yerlesen.has(b.id) || !kimlikGecerliMi(b.sn))
            continue;
        const rol = YUVALAR.find((r) => !yuva[r] && sokumSn(r) === b.sn);
        if (rol)
            yerlestir(b, rol, "sokum");
    }
    const kalan = iki.filter((b) => !yerlesen.has(b.id));
    const bos = YUVALAR.filter((r) => !yuva[r]);
    if (kalan.length === 1 && bos.length === 1)
        yerlestir(kalan[0], bos[0], "diger_hat");
    else
        kalan.forEach((b, i) => { if (bos[i])
            yerlestir(b, bos[i], "sira"); });
    return { C: yuva.C, K: yuva.K, fazla: sirali.length - iki.length, rolCift };
}
/** Formun 1. sayfası taranmamışsa beş ana kalemin hiçbiri okunmamıştır (ana kalem satırları her basımda 1. sayfadadır). */
const ANA_KALEM_SAYFASI = 1;
const sayfaEksik = (m) => m.eksikSayfalar.includes(ANA_KALEM_SAYFASI) ? { sonuc: "kaynak_yok", dayanak: null, isaretler: [{ kod: "sayfa_eksik", deger: String(ANA_KALEM_SAYFASI) }] } : null;
/**
 * Ana gövde (satır 1) birimlerinin geçerli kimlikleri, `seq` sırasıyla ve yinelenmeden: her birimin `sn`'i, `po`'su ve `diger`'i.
 * Motor aynı kolona düşen değerleri " · " ile birleştirir; `po` ve `diger` parçalarına ayrılır (KP-56: MAIN BARREL hücresi üç numara
 * taşıyabilir, kimlik SN kolonunda olmayabilir). Karşılaştırmanın T kümesidir; İLK değer ekrandaki takılan kimliktir ve ana gövde
 * beyanının kimliği de odur (bayat sayfa koruması, köken satırı, olay ve yeniden okuma denetimi aynı değere bakar).
 */
export function anaGovdeKimlikleri(birimler) {
    return tekil(seqSirasi(birimler).flatMap((b) => [b.sn, ...parcala(b.po), ...parcala(b.diger)]).filter(kimlikGecerliMi));
}
/** Ana gövde: MAIN BARREL hücresi iki kimlik uzayına (Assembly SN, MT weldment SN) ve alt parça kimliklerine karşı okunur. */
function anaGovdeSatiri(g) {
    const { oem, sokum, montaj } = g;
    const birimler = seqSirasi(montaj.birimler.filter((b) => b.sira === ANA_KALEM_SATIRI.MB));
    const ilk = birimler[0] ?? null;
    const T = anaGovdeKimlikleri(birimler);
    const A = oem.assembly;
    const W = oem.mtWeldment;
    const P = oem.mtAltParca;
    const sokumSn = sokum.anaGovde?.sn ?? null;
    const S = kimlikGecerliMi(sokumSn) ? sokumSn : null;
    const yazim = birimler.map((b) => b.yazim).filter((x) => Boolean(x)).join(" / ") || null;
    const belirsiz = birimler.some((b) => b.belirsiz);
    const oemVar = A.length + W.length + P.length > 0;
    const kesisen = (d) => T.some((t) => d.includes(t));
    const referanslar = [...A, ...W, ...(S ? [S] : [])];
    const yakin = () => {
        const r = referanslar.find((x) => T.some((t) => birKarakterUzak(t, x)));
        return r ? [{ kod: "kendi_degerine_yakin", deger: r }] : [];
    };
    const karar = (() => {
        const eksik = sayfaEksik(montaj);
        if (eksik)
            return eksik;
        if (!T.length)
            return yazim ? { sonuc: "belirsiz", dayanak: null, isaretler: [{ kod: "kimlik_okunamadi", deger: yazim }] } : { sonuc: "kaynak_yok", dayanak: null, isaretler: [] };
        if (!oemVar && !S)
            return { sonuc: "kaynak_yok", dayanak: null, isaretler: [] };
        const okuma = belirsiz ? [{ kod: "okuma_belirsiz" }] : [];
        if (kesisen(A))
            return { sonuc: "ayni", dayanak: "oem", isaretler: okuma };
        if (kesisen(W))
            return { sonuc: "ayni", dayanak: "oem", isaretler: [{ kod: "mt_weldment" }, ...okuma] };
        if (kesisen(P))
            return { sonuc: "ayni", dayanak: "oem", isaretler: [{ kod: "mt_alt_parca" }, ...okuma] };
        if (S && T.includes(S)) {
            const oemDegeri = (A.length ? A : W.length ? W : P).join(" / ");
            return { sonuc: "ayni", dayanak: "sokum", isaretler: [...(oemVar ? [{ kod: "oem_farkli", deger: oemDegeri }] : []), ...okuma] };
        }
        if ([...A, ...W].some((r) => T.some((t) => ayracsizEsit(t, r))))
            return { sonuc: "yazim_farki", dayanak: "oem", isaretler: okuma };
        if (S && T.some((t) => ayracsizEsit(t, S)))
            return { sonuc: "yazim_farki", dayanak: "sokum", isaretler: okuma };
        const dayanak = oemVar ? "oem" : "sokum";
        if (belirsiz)
            return { sonuc: "belirsiz", dayanak, isaretler: [{ kod: "okuma_belirsiz" }, ...yakin()] };
        return { sonuc: "farkli", dayanak, isaretler: yakin() };
    })();
    const isaretler = [...karar.isaretler];
    if (!montaj.eksikSayfalar.includes(ANA_KALEM_SAYFASI)) {
        // Hücre MT weldment SN'ini ya da alt parça kimliklerini taşıyorsa başlık kutusunun (Assembly SN) farklı olması beklenen şeydir.
        const altUzay = isaretler.some((i) => i.kod === "mt_weldment" || i.kod === "mt_alt_parca");
        if (T.length && montaj.assemblySn && !T.includes(montaj.assemblySn) && !altUzay)
            isaretler.push({ kod: "baslik_farkli", deger: montaj.assemblySn });
        if (karar.sonuc === "farkli" || karar.sonuc === "belirsiz") {
            const d = oem.diger.find((x) => x.yer === "MB" && T.includes(x.sn));
            if (d)
                isaretler.push({ kod: "mrb_diger", deger: d.metin });
        }
        if (birimler.some((b) => b.durum === "sokuldu"))
            isaretler.push({ kod: "sokuldu" });
    }
    const kutu = montaj.assemblySnYazim ?? montaj.assemblySn;
    return {
        kalem: "MB",
        birimId: ilk?.id ?? null,
        oem: oem.durum === "var" ? { sn: A[0] ?? null, yazim: null, ek: [...otekiler(A, A[0] ?? null), ...(W[0] ? [{ tur: "mt_weldment", deger: W[0] }] : [])] } : null,
        cikan: sokum.anaGovde ? { sn: S, yazim: sokum.anaGovde.yazim, ek: sokum.tarih ? [{ tur: "tarih", deger: sokum.tarih }] : [] } : null,
        takilan: birimler.length || kutu ? { sn: T[0] ?? null, yazim, ek: [...otekiler(T, T[0] ?? null), ...(kutu ? [{ tur: "baslik_kutusu", deger: kutu }] : [])] } : null,
        sonuc: karar.sonuc,
        rolFarki: null,
        dayanak: karar.dayanak,
        isaretler,
        rolKaynagi: null,
        bag: ilk?.bag ?? null,
    };
}
const gecerli = (sn) => (kimlikGecerliMi(sn) ? sn : null);
const eskiSn = (b) => gecerli(b?.eski.sn);
function sokumHucresi(b, kayitGunu) {
    const tarih = b.tarih ?? kayitGunu;
    return { sn: eskiSn(b), yazim: b.eski.yazim, ek: [...(b.yeni ? [{ tur: "yeni_id", deger: b.yeni }] : []), ...(tarih ? [{ tur: "tarih", deger: tarih }] : [])] };
}
function hatSatiri(g, x) {
    const { oem, sokum, montaj } = g;
    const birim = x.birim;
    const T = gecerli(birim?.sn);
    const S = eskiSn(x.sokum);
    const Sd = eskiSn(x.sokumDiger);
    const rolsuzSnler = tekil(x.rolsuz.map(eskiSn).filter(kimlikGecerliMi));
    const O = x.oemKumesi;
    const sokumVar = Boolean(S || Sd || rolsuzSnler.length);
    // Yuvadan çıkan birim: rolüyle bu yuvanın birimi; yoksa takılan kimliği taşıyan rolsüz birim.
    const cikanBirimi = x.sokum ?? (T ? (x.rolsuz.find((b) => eskiSn(b) === T) ?? null) : null);
    const yakin = (t) => {
        const r = [S, Sd, ...rolsuzSnler, ...O].find((ref) => ref !== null && birKarakterUzak(t, ref));
        return r ? [{ kod: "kendi_degerine_yakin", deger: r }] : [];
    };
    const karar = (() => {
        const eksik = sayfaEksik(montaj);
        if (eksik)
            return eksik;
        if (!birim)
            return { sonuc: "kaynak_yok", dayanak: null, isaretler: [] };
        if (!T)
            return birim.yazim ? { sonuc: "belirsiz", dayanak: null, isaretler: [{ kod: "kimlik_okunamadi", deger: birim.yazim }] } : { sonuc: "kaynak_yok", dayanak: null, isaretler: [] };
        if (!sokumVar && !O.length)
            return { sonuc: "kaynak_yok", dayanak: null, isaretler: [] };
        const okuma = birim.belirsiz ? [{ kod: "okuma_belirsiz" }] : [];
        const oemFarkli = O.length && !O.includes(T) ? [{ kod: "oem_farkli", deger: O.join(" / ") }] : [];
        if (T === S)
            return { sonuc: "ayni", dayanak: "sokum", isaretler: [...oemFarkli, ...okuma] };
        if (T === Sd)
            return { sonuc: "rol_farki", dayanak: "sokum", isaretler: okuma };
        // Sökümün rolsüz birimi de "çıkan"dır: eşitse dayanak sökümdür ve söküm farkı işareti düşmez.
        if (rolsuzSnler.includes(T))
            return { sonuc: "ayni", dayanak: "sokum", isaretler: [...oemFarkli, ...okuma] };
        if (O.includes(T))
            return { sonuc: "ayni", dayanak: "oem", isaretler: [...(S ? [{ kod: "sokum_farkli", deger: S }] : []), ...okuma] };
        if ([S, ...rolsuzSnler].some((r) => r && ayracsizEsit(T, r)))
            return { sonuc: "yazim_farki", dayanak: "sokum", isaretler: okuma };
        if (O.some((r) => ayracsizEsit(T, r)))
            return { sonuc: "yazim_farki", dayanak: "oem", isaretler: okuma };
        const dayanak = sokumVar ? "sokum" : "oem";
        if (birim.belirsiz)
            return { sonuc: "belirsiz", dayanak, isaretler: [{ kod: "okuma_belirsiz" }, ...yakin(T)] };
        return { sonuc: "farkli", dayanak, isaretler: yakin(T) };
    })();
    const isaretler = [...karar.isaretler];
    const sayfaVar = !montaj.eksikSayfalar.includes(ANA_KALEM_SAYFASI);
    if (sayfaVar) {
        if (birim?.durum === "sokuldu")
            isaretler.push({ kod: "sokuldu" });
        if (cikanBirimi?.isEmriGovdesi) {
            isaretler.push({ kod: "cikan_is_emri", deger: cikanBirimi.eski.yazim ?? cikanBirimi.isEmriGovdesi });
            if (T && cikanBirimi.isEmriGovdesi === T)
                isaretler.push({ kod: "cikan_is_emri_ayni_sayi" });
        }
        if (cikanBirimi && !cikanBirimi.eski.sn && !cikanBirimi.eski.yazim && cikanBirimi.yeni)
            isaretler.push({ kod: "cikan_eski_yok", deger: cikanBirimi.yeni });
        if (T && (karar.sonuc === "farkli" || karar.sonuc === "belirsiz")) {
            const d = oem.diger.find((y) => y.yer === x.digerYeri && y.sn === T);
            if (d)
                isaretler.push({ kod: "mrb_diger", deger: d.metin });
        }
        isaretler.push(...x.yuvaIsaretleri);
    }
    // OEM hücresi: hat atanmışsa o hat; atanmamışsa çıkan ya da takılan kimliği taşıyan hat; o da yoksa iki hat birlikte.
    const oemHucresi = (() => {
        if (oem.durum !== "var")
            return null;
        if (!x.oemHatlari)
            return { sn: O[0] ?? null, yazim: null, ek: otekiler(O, O[0] ?? null) };
        const hucre = (h, sn) => ({ sn, yazim: null, ek: [{ tur: "oem_hat", deger: h.hat }, ...otekiler(h.snler, sn)] });
        const atanmis = x.oemHatlari.find((h) => h.fiziki !== null);
        if (atanmis)
            return hucre(atanmis, [S, T].find((ref) => ref !== null && atanmis.snler.includes(ref)) ?? atanmis.snler[0] ?? null);
        for (const ref of [S, T]) {
            const h = ref ? x.oemHatlari.find((y) => y.snler.includes(ref)) : undefined;
            if (h)
                return hucre(h, ref);
        }
        return { sn: null, yazim: null, ek: x.oemHatlari.filter((h) => h.snler.length).map((h) => ({ tur: "oem_atanmamis", deger: `${h.hat} ${h.snler.join(" | ")}` })) };
    })();
    const cikanHucresi = (() => {
        if (cikanBirimi)
            return sokumHucresi(cikanBirimi, sokum.tarih);
        return rolsuzSnler.length ? { sn: null, yazim: null, ek: rolsuzSnler.map((deger) => ({ tur: "oteki_deger", deger })) } : null;
    })();
    return {
        kalem: x.kalem,
        birimId: birim?.id ?? null,
        oem: oemHucresi,
        cikan: cikanHucresi,
        takilan: birim ? { sn: T, yazim: birim.yazim, ek: [] } : null,
        sonuc: karar.sonuc,
        rolFarki: null,
        dayanak: karar.dayanak,
        isaretler,
        rolKaynagi: x.rolKaynagi,
        bag: birim?.bag ?? null,
    };
}
/** Yuvanın OEM hatları: `fiziki` bu yuvaya atanmış hat varsa yalnız o; yoksa atanmamış hatlar (2A ve 2B birlikte, sırasız küme). */
function ckOemHatlari(oem, yuva) {
    const atanmis = oem.ck.filter((h) => h.fiziki === yuva);
    return atanmis.length ? atanmis : oem.ck.filter((h) => h.fiziki === null);
}
/**
 * Beş ana kalemin karşılaştırması. Saf: aynı girdi hep aynı çıktı; hiçbir şey yazmaz. `satirlar` her zaman beş öğedir,
 * SUREKLILIK_KALEMLERI sırasıyla. Kurallar (ilk tutan geçerlidir):
 *
 * Ana gövde (T = satır 1 birimlerinin geçerli `sn`, `po`, `diger` değerleri; `po` ve `diger` " · " ile bölünür):
 * formun birinci sayfası eksik → kaynak_yok · T boş, yazım dolu → belirsiz (kimlik_okunamadi) · T boş → kaynak_yok · hiç referans
 * yok → kaynak_yok · T ∩ Assembly → ayni (oem) · T ∩ MT weldment → ayni (oem, mt_weldment) · T ∩ alt parça → ayni (oem,
 * mt_alt_parca) · sökümün Assembly SN'i ∈ T → ayni (sokum; OEM varsa oem_farkli) · ayraçsız eşit → yazim_farki · birim belirsiz →
 * belirsiz · değilse farkli (referansa tek karakter uzaksa kendi_degerine_yakin).
 *
 * Hatlar (T = yuvadaki birimin kimliği; S = aynı yuvadan çıkan; Sd = (C, K) öteki yuvadan çıkan; O = OEM kümesi):
 * formun birinci sayfası eksik → kaynak_yok · birim yok → kaynak_yok · T yok, yazım dolu → belirsiz (kimlik_okunamadi) · hiç
 * referans yok → kaynak_yok · T = S → ayni (sokum; T ∉ O ise oem_farkli) · T = Sd → rol_farki (sokum) · T sökümün rolsüz biriminde →
 * ayni (sokum) · T ∈ O → ayni (oem; S doluysa sokum_farkli) · ayraçsız eşit → yazim_farki · birim belirsiz → belirsiz · değilse
 * farkli (S, Sd ya da O'ya tek karakter uzaksa kendi_degerine_yakin). `mrb_diger` sonucu DEĞİŞTİRMEZ. Eşit çıkan satırda birim
 * belirsiz okunmuşsa eşitlik bozulmaz, `okuma_belirsiz` işareti düşer.
 *
 * `geriTakilmayan`: sökümün hat birimlerinden, kimliği montajın hiçbir hat biriminde olmayan ve kaleminin sonucu `farkli` ya da
 * `rol_farki` olanlar (sonuç `ayni` + `sokum_farkli` ise fark söküm okumasındadır; o değer listelenmez).
 */
export function montajKarsilastir(g) {
    const { oem, sokum, montaj } = g;
    const yuvalar = ckYuvalari(montaj.birimler, sokum.ck);
    const rolsuz = sokum.ck.filter((b) => b.rol === null);
    const ilkBirim = (sira) => seqSirasi(montaj.birimler.filter((b) => b.sira === sira))[0] ?? null;
    const ayniSn = Boolean(yuvalar.C && yuvalar.K && kimlikGecerliMi(yuvalar.C.birim.sn) && yuvalar.C.birim.sn === yuvalar.K.birim.sn);
    const ckSatiri = (yuva) => {
        const y = yuvalar[yuva];
        const hatlar = ckOemHatlari(oem, yuva);
        const isaretler = [];
        if (y) {
            if (ayniSn)
                isaretler.push({ kod: "ayni_sn_iki_birim" });
            // Formda harfi olan birim harfiyle yerleşemediyse (iki birim aynı harf) "rol yazılmamış" denmez; `rol_cift` söyler.
            if (!y.birim.rol && (y.kaynak === "sokum" || y.kaynak === "diger_hat"))
                isaretler.push({ kod: "rol_yazilmamis", deger: y.kaynak });
            if (!y.birim.rol && y.kaynak === "sira")
                isaretler.push({ kod: "rol_sirayla" });
            if (yuvalar.rolCift)
                isaretler.push({ kod: "rol_cift" });
            if (yuvalar.fazla > 0)
                isaretler.push({ kod: "fazla_birim", deger: String(yuvalar.fazla) });
        }
        return hatSatiri(g, {
            kalem: yuva,
            birim: y?.birim ?? null,
            rolKaynagi: y?.kaynak ?? null,
            sokum: sokum.ck.find((b) => b.rol === yuva) ?? null,
            sokumDiger: sokum.ck.find((b) => b.rol !== null && b.rol !== yuva) ?? null,
            rolsuz,
            oemKumesi: tekil(hatlar.flatMap((h) => h.snler)),
            oemHatlari: hatlar,
            digerYeri: "CK",
            yuvaIsaretleri: isaretler,
        });
    };
    const tekHat = (kalem) => hatSatiri(g, {
        kalem,
        birim: ilkBirim(kalem === "B" ? ANA_KALEM_SATIRI.B : ANA_KALEM_SATIRI.H),
        rolKaynagi: null,
        sokum: kalem === "B" ? sokum.booster : sokum.hidrolik,
        sokumDiger: null,
        rolsuz: [],
        oemKumesi: kalem === "B" ? oem.booster : oem.hidrolik,
        oemHatlari: null,
        digerYeri: kalem,
        yuvaIsaretleri: [],
    });
    const c = ckSatiri("C");
    const k = ckSatiri("K");
    // Tek hat öteki yuvadaysa "now in the other slot"; iki hat karşılıklı yer değiştirdiyse "swapped".
    const rolFarki = c.sonuc === "rol_farki" && k.sonuc === "rol_farki" ? "karsilikli" : "oteki_yuva";
    for (const s of [c, k])
        if (s.sonuc === "rol_farki")
            s.rolFarki = rolFarki;
    const satirlar = [anaGovdeSatiri(g), c, k, tekHat("B"), tekHat("H")];
    const hatSatirlari = [ANA_KALEM_SATIRI.CK, ANA_KALEM_SATIRI.B, ANA_KALEM_SATIRI.H];
    const takili = new Set(montaj.birimler.filter((b) => hatSatirlari.includes(b.sira)).map((b) => b.sn).filter(kimlikGecerliMi));
    const degisti = (kalem) => {
        const s = satirlar.find((y) => y.kalem === kalem)?.sonuc;
        return s === "farkli" || s === "rol_farki";
    };
    const geriTakilmayan = [];
    const ekle = (kalem, b) => {
        const sn = eskiSn(b);
        if (!sn || takili.has(sn) || geriTakilmayan.some((y) => y.sn === sn))
            return false;
        geriTakilmayan.push({ kalem, sn, yazim: b.eski.yazim });
        return true;
    };
    // Rolsüz söküm biriminin yuvası bilinmez: sonucu değişen C / K satırlarına sırayla yazılır.
    const rolsuzYuvalari = YUVALAR.filter(degisti);
    let rolsuzNo = 0;
    for (const b of seqSirasi(sokum.ck)) {
        if (b.rol) {
            if (degisti(b.rol))
                ekle(b.rol, b);
        }
        else if (rolsuzYuvalari.length && ekle(rolsuzYuvalari[Math.min(rolsuzNo, rolsuzYuvalari.length - 1)], b))
            rolsuzNo++;
    }
    if (sokum.booster && degisti("B"))
        ekle("B", sokum.booster);
    if (sokum.hidrolik && degisti("H"))
        ekle("H", sokum.hidrolik);
    return { satirlar, geriTakilmayan };
}
/** Yerin ekran adı (İngilizce sabit; web `cevir(degisken)` ile gösterir). */
export const FILO_YERI_ADI = {
    MB: "Assembly SN",
    MT: "MT weldment SN",
    "2A": "C&K line 2A",
    "2B": "C&K line 2B",
    C: "Choke",
    K: "Kill",
    CK: "C&K line",
    B: "Booster",
    H: "Hydraulic",
};
const ANA_GOVDE_YERLERI = ["MB", "MT"];
export const ADAY_SINIRLARI = { tam: 6, yakin: 3, stok: 3 };
const isoGun = (t) => (typeof t === "string" && /^\d{4}-\d{2}-\d{2}/.test(t) ? t.slice(0, 10) : null);
/** Vericinin söküm günü, alıcının montaj gününden sonra olamaz. Biri bilinmiyorsa "bilinmiyor". Aynı gün "uygun". */
export function zamanSirasi(vericiSokumGunu, aliciMontajGunu) {
    const s = isoGun(vericiSokumGunu);
    const m = isoGun(aliciMontajGunu);
    if (!s || !m)
        return "bilinmiyor";
    return s <= m ? "uygun" : "ters";
}
/**
 * Bu riserdan sökülen hattın başka riserın montaj kaydında görünmesinin zamanı (Riser Documentation, `SimdiTakili.zaman`):
 * o montajın günü bu sökümün gününden önce değilse "sonra", önceyse "once", biri bilinmiyorsa "bilinmiyor".
 */
export function simdiTakiliZamani(sokumGunu, montajGunu) {
    const z = zamanSirasi(sokumGunu, montajGunu);
    return z === "uygun" ? "sonra" : z === "ters" ? "once" : "bilinmiyor";
}
/** Adayın İngilizce tek cümlesi (olay kaydı ve yedek gösterim). */
export function adayAciklamasi(a) {
    const yer = a.yer ? FILO_YERI_ADI[a.yer] : null;
    const p = a.kaynak === "stok"
        ? [`Stock package ${a.paketNo === undefined ? "" : pkgNo(a.paketNo)}`.trim(), a.pn ?? null, a.stokEslesme === "po" ? "PO matches" : "trace matches"]
        : a.kaynak === "mrb"
            ? a.rn
                ? [a.rn, `OEM record (MRB ${a.mrbSn ?? "?"})`, yer]
                : [`MRB ${a.mrbSn ?? "?"} (not linked to a riser)`, yer]
            : a.kaynak === "sokum"
                ? [a.rn ?? null, "Disassembly record", yer, a.yeni ? `new ID ${a.yeni}` : null, a.tarih ? `removed ${a.tarih}` : null]
                : [a.rn ?? null, "assembly record", yer, a.tarih ? `assembled ${a.tarih}` : null];
    const metin = p.filter(Boolean).join(" · ");
    return a.eslesme === "yakin" ? `similar, not a suggestion: ${a.sn} (${metin})` : metin;
}
const KAYNAK_SIRASI = { sokum: 0, montaj: 1, mrb: 2 };
/** Doğal sıra ("R9", "R10"dan önce); riseri olmayan (bağsız MRB) sonda. */
const rnSirasi = (a, b) => (a === b ? 0 : a === null ? 1 : b === null ? -1 : a.localeCompare(b, "en", { numeric: true }));
/** Kimliğin kökü: son tireden önceki kısım. */
const kok = (sn) => {
    const i = sn.lastIndexOf("-");
    return i > 0 ? sn.slice(0, i) : sn;
};
/**
 * `aranan` kimliğin dizindeki eşleşmeleri. `kalem` MB ise yalnız MB ve MT yerlerine, hat kalemiyse bütün hat yerlerine (2A, 2B, C,
 * K, CK, B, H) bakılır: hat tipi sınırı yoktur (booster'da aranan kimlik başka riserın Kill hattıysa o da çıkar).
 * tam: `kimlikIliskisi` "ayni" ya da "yazim"; sıra kaynak (söküm → montaj → MRB), sonra riser numarası. yakin: "yakin"; kökü
 * arananla aynı olanlar önce, sonra riser numarası. Tek karakter uzaklık ÖNERİ DEĞİLDİR: yanlış okunan hane başka riserı gösterir.
 * Söküm kaynağında `zaman` (vericinin söküm günü ↔ `montajGunu`), montaj kaynağında `celiski: true` yazılır. Geçersiz kimlikte boş.
 */
export function montajAdaylari(g) {
    if (!kimlikGecerliMi(g.aranan))
        return { tam: [], tamSayisi: 0, yakin: [], yakinSayisi: 0 };
    const aday = (k, eslesme) => {
        const a = {
            kaynak: k.kaynak,
            ...(k.rn ? { rn: k.rn } : {}),
            eslesme,
            sn: k.sn,
            yer: k.yer,
            ...(k.mrbSn !== undefined ? { mrbSn: k.mrbSn } : {}),
            tarih: k.tarih,
            ...(k.kaynak === "sokum" ? { zaman: zamanSirasi(k.tarih, g.montajGunu) } : {}),
            ...(k.kaynak === "montaj" ? { celiski: true } : {}),
            ...(k.kayitId !== undefined ? { kayitId: k.kayitId } : {}),
            ...(k.kaynak === "sokum" && k.yeni ? { yeni: k.yeni } : {}),
        };
        return { ...a, aciklama: adayAciklamasi(a) };
    };
    const tam = [];
    const yakin = [];
    for (const k of g.dizin) {
        if (ANA_GOVDE_YERLERI.includes(k.yer) !== (g.kalem === "MB"))
            continue;
        const i = kimlikIliskisi(g.aranan, k.sn);
        if (i === "ayni" || i === "yazim")
            tam.push(k);
        else if (i === "yakin")
            yakin.push(k);
    }
    tam.sort((a, b) => KAYNAK_SIRASI[a.kaynak] - KAYNAK_SIRASI[b.kaynak] || rnSirasi(a.rn, b.rn));
    const arananKok = kok(g.aranan);
    const ayniKok = (k) => (kok(k.sn) === arananKok ? 0 : 1);
    yakin.sort((a, b) => ayniKok(a) - ayniKok(b) || rnSirasi(a.rn, b.rn) || (a.sn < b.sn ? -1 : a.sn > b.sn ? 1 : 0) || KAYNAK_SIRASI[a.kaynak] - KAYNAK_SIRASI[b.kaynak]);
    const ciftler = new Set();
    const gosterilen = tam.length
        ? []
        : yakin.filter((k) => {
            const anahtar = `${k.sn}|${k.rn ?? ""}`;
            if (!ciftler.has(anahtar) && ciftler.size >= ADAY_SINIRLARI.yakin)
                return false;
            ciftler.add(anahtar);
            return true;
        });
    return {
        tam: tam.slice(0, ADAY_SINIRLARI.tam).map((k) => aday(k, "tam")),
        tamSayisi: tam.length,
        yakin: gosterilen.map((k) => aday(k, "yakin")),
        yakinSayisi: new Set(yakin.map((k) => k.sn)).size,
    };
}
/**
 * Stok adayı: satırın basılı OSI PN'ini (ya da birimin yazdığı PN'i) taşıyan paketlerde iz ve PO eşleşmesi. Paketin `iz` metni
 * boşluk, virgül, noktalı virgül, eğik çizgi, dikey çizgi ve "·" ile parçalanır; her parça `sadeKimlik` ile birimin `sn`, `heat`
 * ve `diger` değerleriyle karşılaştırılır; ya da paketin PO'su birimin `po`'suna aynı normalleştirmeyle eşittir. Biri tutuyorsa
 * aday ("tam"); hiçbiri tutmuyorsa aday değildir. Stokta "yakın" kullanılmaz. En çok ADAY_SINIRLARI.stok satır, paket numarası sırasıyla.
 */
export function stokAdaylari(g) {
    const pnler = new Set([g.osiPn, g.birim.pn].map(sadeKimlik).filter(Boolean));
    const kimlikler = new Set([g.birim.sn, g.birim.heat, ...parcala(g.birim.diger)].map(sadeKimlik).filter(Boolean));
    const po = sadeKimlik(g.birim.po);
    const adaylar = [];
    for (const p of [...g.paketler].sort((a, b) => a.no - b.no)) {
        if (!pnler.has(sadeKimlik(p.pn)))
            continue;
        const iz = (p.iz ?? "").split(/[\s,;/|·]+/).filter(Boolean).find((x) => kimlikler.has(sadeKimlik(x)));
        const poTutuyor = Boolean(po) && sadeKimlik(p.poNo) === po;
        if (!iz && !poTutuyor)
            continue;
        const a = { kaynak: "stok", paketId: p.id, eslesme: "tam", sn: iz ?? p.poNo ?? "", paketNo: p.no, pn: p.pn, stokEslesme: iz ? "iz" : "po" };
        adaylar.push({ ...a, aciklama: adayAciklamasi(a) });
        if (adaylar.length >= ADAY_SINIRLARI.stok)
            break;
    }
    return adaylar;
}
/**
 * "From another riser…" penceresinde verici riser girişinin ön-doldurması (yalnız girişi doldurur; kişi "Confirm"e basmadan hiçbir
 * şey yazılmaz). Üç koşul BİRLİKTE tutarsa riser, tutmazsa null:
 * (a) "tam" adayların gösterdiği riser tektir ve aday o riserın SÖKÜM kaydından gelir · (b) söküm adayının zamanı "uygun"dur ·
 * (c) satırda `kendi_degerine_yakin` işareti yoktur.
 * Yalnız MRB'den (ya da yalnız montaj kaydından) gelen "tam" eşleşme önceden doldurmaz: parçanın vericiden ayrıldığını göstermez.
 * Listede gösterilmeyen tam aday varsa (`tamSayisi` > `tam.length`) riserın tek olduğu bilinemez: null. "Yakın" aday hiç doldurmaz.
 */
export function beyanOnDoldurmaRn(s) {
    if (s.isaretler.some((i) => i.kod === "kendi_degerine_yakin"))
        return null;
    const { tam, tamSayisi } = s.adaylar;
    if (tamSayisi > tam.length)
        return null;
    const riserler = tekil(tam.map((a) => a.rn).filter((x) => Boolean(x)));
    if (riserler.length !== 1)
        return null;
    const sokum = tam.filter((a) => a.kaynak === "sokum");
    return sokum.length > 0 && sokum.every((a) => a.zaman === "uygun") ? riserler[0] : null;
}
/**
 * Riser Documentation'ın "Fitted (assembly)" hücresi: Assembly sayfasıyla AYNI karşılaştırmadan çıkar. Kalemin takılan hücresi
 * yoksa (yuvada birim yok) null. `paketNo`: stok beyanının paket numarası (servis bulur; paket silinmişse ya da seçilmemişse null).
 * `formSirasi`: rol formda yazmıyor ve hatlar yazılış sırasıyla gösteriliyorsa (rolKaynagi "sira") formun 3. satırındaki numaralar.
 */
export function izlenebilirlikTakilan(satirlar, kalem, paketNo = null) {
    const s = satirlar.find((x) => x.kalem === kalem);
    if (!s?.takilan)
        return null;
    const isaret = (kod) => s.isaretler.some((i) => i.kod === kod);
    const formSirasi = s.rolKaynagi === "sira"
        ? YUVALAR.map((y) => satirlar.find((x) => x.kalem === y && x.rolKaynagi === "sira")?.takilan).map((t) => t?.sn ?? t?.yazim ?? null).filter((x) => Boolean(x))
        : null;
    return {
        sn: s.takilan.sn,
        yazim: s.takilan.yazim,
        sonuc: s.sonuc,
        dayanak: s.dayanak,
        rolFarki: s.rolFarki,
        rolKaynagi: s.rolKaynagi,
        formSirasi,
        okumaBelirsiz: isaret("okuma_belirsiz"),
        sokuldu: isaret("sokuldu"),
        bag: s.bag ? { tur: s.bag.tur, rn: s.bag.rn, paketNo: s.bag.tur === "stok" ? (paketNo ?? s.bag.paketNo ?? null) : null } : null,
    };
}
export const MONTAJ_BAG_NOT_SINIRI = 500;
/** Beyan ret cümleleri (İngilizce; sunucu aynen yazar, web sözlükten çevirir). */
export const MONTAJ_BAG_HATALARI = {
    tamamlanmadi: "Continuity is declared after the assembly record is completed.",
    anaKalemDegil: "Continuity can be declared only on the main barrel and the four lines.",
    turBilinmiyor: "Unknown declaration.",
    bayat: "The assembly record was changed meanwhile; refresh the page.",
    kimlikYok: "This line has no fitted identity on the assembly record; only “Unknown” can be declared.",
    rolYeri: "Role can be set only on a C&K line.",
    riserYok: "Enter the riser the part came from.",
    riserGecersiz: "Riser number is not valid.",
    kendiRiseri: "A riser cannot be the donor of its own line or part.",
    rolGerekli: "Choose Choke or Kill for this line first.",
    notUzun: `Note is too long (at most ${MONTAJ_BAG_NOT_SINIRI} characters).`,
};
export const montajBagRolDoluHatasi = (rol) => `The assembly record already gives this line the role ${ROL_ADI[rol]}; it cannot be changed here.`;
export const montajBagRolAlinmisHatasi = (rol) => `The other C&K line already has the role ${ROL_ADI[rol]}.`;
/** Beyan yalnız tamamlanmış kayıtta yapılır: hâl `okundu` ya da `form_kapali`. */
export const montajBeyanAcik = (hal) => hal === "okundu" || hal === "form_kapali";
const metinMi = (x) => typeof x === "string" && x.trim() !== "";
/**
 * Beyanın veri gerektirmeyen ve birime bağlı kuralları. Hata varsa `hata` İngilizce cümledir ve `plan` null'dır; `bayat` yalnız
 * 4. kuralda true'dur (sunucu 409 döner; ötekiler 400). Kurallar, sırayla (ilk tutmayan döner):
 * 1. Kayıt tamamlanmış olmalı (`montajBeyanAcik`).
 * 2. Birim ana kalem satırında olmalı: satır 1, 4 ve 5'te `seq`'i en küçük birim; satır 3'te `seq`'i en küçük iki birimden biri.
 * 3. Tür sözlükte olmalı.
 * 4. Gövdedeki `sn` birimin temiz kimliğine eşit olmalı (ikisi de boş olabilir).
 * 5. `ayni`, `baska_riser`, `stok` için birimin kimliği geçerli olmalı.
 *    4 ve 5'teki kimlik `birim.sn`'dir: çağıran onu beyan kimliği olarak verir. Hatlarda birimin saklanan `sn`'i; ana gövdede
 *    satırın takılan kimliği (`anaGovdeKimlikleri`'nin ilki: ekranda gösterilen değer; kimlik `po` ya da `diger`'de olabilir).
 * 6. Rol verildiyse birim satır 3'te ve değer C ya da K olmalı.
 * 7. Rol verildiyse ve FORMDAKİ rol dolu ve farklıysa reddedilir (formda yazan aynen alınır; kişi yalnız boş rolü doldurur).
 * 8. Rol verildiyse ve öteki C&K birimi o rolü taşıyorsa (`rol ?? rolSecim`) reddedilir.
 * 9. `baska_riser`: riser dolu ve okunur olmalı. 10. Verici bu riser olamaz.
 * 11. `baska_riser`, satır 3: birimin rolü (formdan, gövdeden ya da önceki seçimden) bilinmeli.
 * 12. Not en çok MONTAJ_BAG_NOT_SINIRI karakter.
 * 13. `paketId` yalnız `stok`'ta, `rn` yalnız `baska_riser`'da okunur; öteki türlerde verilse de yok sayılır.
 * Engelleme yoktur: sonuç `farkli` iken "Same part", `ayni` iken "From another riser" de kabul edilir (bu fonksiyon sonucu görmez).
 */
export function montajBagHazirla(g) {
    const ret = (hata, bayat = false) => ({ hata, bayat, plan: null });
    const { birim, govde } = g;
    if (!montajBeyanAcik(g.hal))
        return ret(MONTAJ_BAG_HATALARI.tamamlanmadi);
    const kardesler = g.kardesler.filter((k) => k.id !== birim.id);
    const onde = kardesler.filter((k) => k.seq < birim.seq).length;
    const anaKalem = birim.sira === ANA_KALEM_SATIRI.CK ? onde < 2 : (birim.sira === ANA_KALEM_SATIRI.MB || birim.sira === ANA_KALEM_SATIRI.B || birim.sira === ANA_KALEM_SATIRI.H) && onde === 0;
    if (!anaKalem)
        return ret(MONTAJ_BAG_HATALARI.anaKalemDegil);
    if (!montajBagTuruMu(govde.tur))
        return ret(MONTAJ_BAG_HATALARI.turBilinmiyor);
    const tur = govde.tur;
    if ((metinMi(govde.sn) ? govde.sn : null) !== (birim.sn || null))
        return ret(MONTAJ_BAG_HATALARI.bayat, true);
    if (tur !== "bilinmiyor" && !kimlikGecerliMi(birim.sn))
        return ret(MONTAJ_BAG_HATALARI.kimlikYok);
    const rolVerildi = govde.rol !== null && govde.rol !== undefined && govde.rol !== "";
    let govdeRol = null;
    if (rolVerildi) {
        if (birim.sira !== ANA_KALEM_SATIRI.CK || !rolMu(govde.rol))
            return ret(MONTAJ_BAG_HATALARI.rolYeri);
        govdeRol = govde.rol;
        if (birim.rol && birim.rol !== govdeRol)
            return ret(montajBagRolDoluHatasi(birim.rol));
        // Öteki C&K birimi: satırın `seq`'i en küçük iki biriminden bu birim olmayanı.
        const oteki = seqSirasi(kardesler)[0] ?? null;
        if (oteki && (oteki.rol ?? oteki.rolSecim) === govdeRol)
            return ret(montajBagRolAlinmisHatasi(govdeRol));
    }
    let bagRn = null;
    if (tur === "baska_riser") {
        if (!metinMi(govde.rn))
            return ret(MONTAJ_BAG_HATALARI.riserYok);
        bagRn = riserRnOku(govde.rn);
        if (!bagRn)
            return ret(MONTAJ_BAG_HATALARI.riserGecersiz);
        if (bagRn === (riserRnOku(g.rn) ?? g.rn))
            return ret(MONTAJ_BAG_HATALARI.kendiRiseri);
    }
    const rol = birim.rol ?? govdeRol ?? birim.rolSecim;
    if (tur === "baska_riser" && birim.sira === ANA_KALEM_SATIRI.CK && !rol)
        return ret(MONTAJ_BAG_HATALARI.rolGerekli);
    const bagNot = metinMi(govde.not) ? govde.not.trim() : null;
    if (bagNot && bagNot.length > MONTAJ_BAG_NOT_SINIRI)
        return ret(MONTAJ_BAG_HATALARI.notUzun);
    const bagPaketId = tur === "stok" && metinMi(govde.paketId) ? govde.paketId.trim() : null;
    const rolYaz = birim.rol ? null : govdeRol;
    const hat = birim.sira === ANA_KALEM_SATIRI.MB ? "Main" : birim.sira === ANA_KALEM_SATIRI.B ? "Booster" : birim.sira === ANA_KALEM_SATIRI.H ? "Hydraulic" : rol ? KALEM_HATTI[rol] : null;
    const b = birim.bag;
    const ayni = b !== null && b.tur === tur && (b.rn ?? null) === bagRn && (b.paketId ?? null) === bagPaketId && (b.not ?? null) === bagNot && (rolYaz === null || rolYaz === birim.rolSecim);
    return { hata: null, bayat: false, plan: { tur, bagRn, bagPaketId, bagNot, rolYaz, hat, ayni } };
}
/**
 * Yeni okumanın beyanlı birimlere etkisi. Her beyanlı birim için yeni okumadaki AYNI (sira, seq) birim aranır: yoksa engel
 * (`yeniBirimVar: false`); varsa ve temiz kimliği (`sn`) öncekiyle aynı değilse engel. Kimlik aynıysa engel yok.
 * `sn` iki listede de beyan kimliğidir (`montajBagHazirla` kural 4): ana gövdede satırın takılan kimliği (`anaGovdeKimlikleri`'nin ilki).
 * C&K satırında kimlik aynı olsa da birimin YUVASI değişecekse de engel: eski yuva `rol ?? rolSecim`, yeni yuva yeni okumanın
 * harfi `?? rolSecim` (`rol_secim` yazımda korunur; okuma yalnız formdaki harfi yazar). Yeni listede `rol` verilmemişse
 * (`undefined`) yuva denetlenmez. Gerekçe: beyanın köken satırı hattın yuvasına (Choke / Kill) bağlıdır; yuvası değişen beyan
 * başka hatta taşınmış olur.
 * Beyansız birimlerdeki değişiklik engel üretmez. Dönen dizi boşsa okuma yazılabilir.
 * Gerekçe: beyan belirli bir kimlik için, `mrb` yetkisiyle verilmiştir; onu düşük yetkiyle ya da makine anahtarıyla silmek ya da
 * başka birime taşımak bir kimlik kararıdır. Beyan taşınmaz ve düşürülmez; okuma reddedilir.
 */
export function montajBeyanEngeli(beyanlilar, yeniler) {
    const engeller = [];
    const rolu = (x) => (rolMu(x) ? x : null);
    for (const b of beyanlilar) {
        const yeni = yeniler.find((y) => y.sira === b.sira && y.seq === b.seq);
        const eskiSnDegeri = b.sn || null;
        if (!yeni)
            engeller.push({ sira: b.sira, seq: b.seq, eskiSn: eskiSnDegeri, yeniSn: null, yeniBirimVar: false });
        else if ((yeni.sn || null) !== eskiSnDegeri)
            engeller.push({ sira: b.sira, seq: b.seq, eskiSn: eskiSnDegeri, yeniSn: yeni.sn || null, yeniBirimVar: true });
        else if (b.sira === ANA_KALEM_SATIRI.CK && yeni.rol !== undefined) {
            const eskiRol = rolu(b.rol) ?? rolu(b.rolSecim);
            const yeniRol = rolu(yeni.rol) ?? rolu(b.rolSecim);
            if (eskiRol !== yeniRol)
                engeller.push({ sira: b.sira, seq: b.seq, eskiSn: eskiSnDegeri, yeniSn: eskiSnDegeri, yeniBirimVar: true, eskiRol, yeniRol });
        }
    }
    return engeller;
}
/** Yeniden okuma reddinin cümlesi (İngilizce; elle yüklemede 409 gövdesi, dönüştürücü tesliminde ret sebebi olarak aynen). */
export function montajBeyanEngeliCumlesi(e) {
    // Yuva değişiminde iki değer aynı kimliği taşır; yuva parantez içinde eklenir (Choke / Kill / no role).
    const yuva = (r) => (r === undefined ? "" : ` (${r ? ROL_ADI[r] : "no role"})`);
    const eski = `${e.eskiSn ?? "no identity"}${yuva(e.eskiRol)}`;
    const yeni = !e.yeniBirimVar ? "no unit" : `${e.yeniSn ?? "no identity"}${yuva(e.yeniRol)}`;
    return `The new reading changes ${montajAnaKalemAdi(e.sira)} (row ${e.sira} unit ${e.seq}), which carries a continuity declaration: ${eski} would become ${yeni}. Remove the declaration first (MRB permission), then read the input.`;
}
//# sourceMappingURL=montaj-sureklilik.js.map